/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesEmailTemplatePurpose } from './WebApiModelsEnumerationTypesEmailTemplatePurpose';
import {
    WebApiModelsEnumerationTypesEmailTemplatePurposeFromJSON,
    WebApiModelsEnumerationTypesEmailTemplatePurposeFromJSONTyped,
    WebApiModelsEnumerationTypesEmailTemplatePurposeToJSON,
} from './WebApiModelsEnumerationTypesEmailTemplatePurpose';

/**
 * 
 * @export
 * @interface WebApiServicesDataTransferObjectsEmailServiceCreateEmailTemplateDto
 */
export interface WebApiServicesDataTransferObjectsEmailServiceCreateEmailTemplateDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsEmailServiceCreateEmailTemplateDto
     */
    templateName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsEmailServiceCreateEmailTemplateDto
     */
    subject?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsEmailServiceCreateEmailTemplateDto
     */
    body?: string | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesEmailTemplatePurpose}
     * @memberof WebApiServicesDataTransferObjectsEmailServiceCreateEmailTemplateDto
     */
    purpose?: WebApiModelsEnumerationTypesEmailTemplatePurpose;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsEmailServiceCreateEmailTemplateDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsEmailServiceCreateEmailTemplateDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsEmailServiceCreateEmailTemplateDtoFromJSON(json: any): WebApiServicesDataTransferObjectsEmailServiceCreateEmailTemplateDto {
    return WebApiServicesDataTransferObjectsEmailServiceCreateEmailTemplateDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsEmailServiceCreateEmailTemplateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsEmailServiceCreateEmailTemplateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'templateName': !exists(json, 'templateName') ? undefined : json['templateName'],
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
        'body': !exists(json, 'body') ? undefined : json['body'],
        'purpose': !exists(json, 'purpose') ? undefined : WebApiModelsEnumerationTypesEmailTemplatePurposeFromJSON(json['purpose']),
    };
}

export function WebApiServicesDataTransferObjectsEmailServiceCreateEmailTemplateDtoToJSON(value?: WebApiServicesDataTransferObjectsEmailServiceCreateEmailTemplateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'templateName': value.templateName,
        'subject': value.subject,
        'body': value.body,
        'purpose': WebApiModelsEnumerationTypesEmailTemplatePurposeToJSON(value.purpose),
    };
}

